import { render, staticRenderFns } from "./DissolveCommission.vue?vue&type=template&id=efed479c"
import script from "./DissolveCommission.vue?vue&type=script&lang=js"
export * from "./DissolveCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports